/* eslint 'array-callback-return': 'off','no-array-constructor': 'off','no-loop-func':'off',eqeqeq: 'off'  */
import * as types from '../action/actionTypes';
import * as url from '../api/url';
import APIutil from '../api/APIutils';
import randomColor from 'randomcolor';
import {global_error_handling} from './GlobalErrorMgmtAction';
import {getRequestsList} from './facilitiesAction';

export function GetAllRequests() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Request).then(response => {
            if (response.hasOwnProperty('data')) {
            dispatch(global_error_handling(response));  }
            else if(response != null && response != undefined){
                let updated_data = new Array();
                var colorObject =new Array();
                var get_sessionStored_ColorObj =    JSON.parse(localStorage.getItem("uploaded_colorObj"));       //Fetching category color from session object if available

                let unique_tenantID_Array = response.data !== "" ? [...new Set(response.map(item => item.tenantId))] : [];   // identifying or sorting unique tenant id's to an array
                //Generating unique color for each tenant
                for (var j = 0; j < unique_tenantID_Array.length; j++) {
                    var unique_color_for_tenant = randomColor.randomColor({ luminosity: 'bright' });   // generating random color 
                    for (var i = 0; i < response.length; i++) {
                        if (response[i].tenantId === unique_tenantID_Array[j]) {
                            var o = Object.assign({}, response[i]);
                            var  unique_color_from_session = null;
                        if(get_sessionStored_ColorObj !==null){                     //Comparing the session object for colors, if available assigning the color 
                             get_sessionStored_ColorObj.filter(function(e) {
                                if(e.tenantid ===response[i].tenantId ){
                                    unique_color_from_session = e.CategoryColor;
                                }
                            });
                        }
                        (unique_color_from_session !== null) ?   o.CategoryColor = unique_color_from_session : o.CategoryColor = unique_color_for_tenant;   //assigning the categor color from 
                            var sessionObj = {                //Storing the categorycolor alomng with tenantID  in Session as objects of array
                                tenantid: response[i].tenantId,
                                CategoryColor : o.CategoryColor,
                              };
                            colorObject.push(sessionObj);
                            localStorage.setItem("uploaded_colorObj",JSON.stringify(colorObject));     //stringifying the object  to set item in session storage
                            updated_data.push(o);
                        }
                    }
                }
                dispatch(actionToStoreSuccess(updated_data,types.GET_REQUESTS_SUCCESSFULL));
            }
        }).catch(error => {
            throw error;
        })
    }
}

export function GetAllPastRequests(fromDate, toDate){
    return function(dispatch){
        var pastRequestDate = {
            "FromDate": fromDate,
            "ToDate": toDate,
        }
        return APIutil.postData(url.get_PastRequest,pastRequestDate).then(response => {
            dispatch(global_error_handling(response));
            if(response.data !== null && response.data !== undefined){
                let updated_data = new Array();
                var colorObject = new Array();
                var get_sessionStored_ColorObj = JSON.parse(localStorage.getItem("uploaded_colorObj")); 
                let unique_tenantID_Array = response.data !== "" ? [...new Set(response.data.map(item => item.tenantId))] : []; 
                for (var j = 0; j < unique_tenantID_Array.length; j++) {
                    var unique_color_for_tenant = randomColor.randomColor({ luminosity: 'bright' });   // generating random color 
                    for (var i = 0; i < response.data.length; i++) {
                        if (response.data[i].tenantId === unique_tenantID_Array[j]) {
                            var o = Object.assign({}, response.data[i]);
                            var  unique_color_from_session = null;
                        if(get_sessionStored_ColorObj !==null){                     //Comparing the session object for colors, if available assigning the color 
                             get_sessionStored_ColorObj.filter(function(e) {
                                if(e.tenantid ===response.data[i].tenantId ){
                                    unique_color_from_session = e.CategoryColor;
                                }
                            });
                        }
                        (unique_color_from_session !== null) ?   o.CategoryColor = unique_color_from_session : o.CategoryColor = unique_color_for_tenant;   //assigning the categor color from 
                            var sessionObj = {                //Storing the categorycolor alomng with tenantID  in Session as objects of array
                                tenantid: response.data[i].tenantId,
                                CategoryColor : o.CategoryColor,
                              };
                            colorObject.push(sessionObj);
                            localStorage.setItem("uploaded_colorObj",JSON.stringify(colorObject));     //stringifying the object  to set item in session storage
                            updated_data.push(o);
                        }
                    }
                }
                dispatch(actionToStoreSuccess(updated_data,types.GET_PASTREQUESTS_SUCCESSFUL));
            }
        }).catch(error => {throw error;})
    }
}

export function GetSelectedRequest(id) { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_Request+"/"+id).then(response => {
            dispatch(global_error_handling(response));  
            if(response != null && response != undefined)
            dispatch(actionToStoreSuccess(response,types.GET_SELECTED_REQUEST_SUCCESSFULL));
            return response;
        }).catch(error => {
            throw error;
        })
    }
}

export function GetSelectedPastRequest(id) {
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_PastRequest+"/"+id).then(response => {
            dispatch(global_error_handling(response));  
            if(response != null && response != undefined)
            dispatch(actionToStoreSuccess(response,types.GET_SELECTED_REQUEST_SUCCESSFULL));
            return response;
        }).catch(error => {
            throw error;
        })
    }
}


export function GetTimeZoneForZone() { 
    return function (dispatch) {
        return APIutil.getDataAPI(url.get_zone_timezone).then(response => {
            dispatch(global_error_handling(response));  
             if(response != null && response != undefined)
            dispatch(actionToStoreSuccess(response,types.GET_ZONE_TIMEZONE_DETAIL));
            return response;
        }).catch(error => {
            throw error;
        })
    }
}

export function SaveRequest(data) { 
    return function (dispatch) {
        return APIutil.postData(url.post_Request,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(getRequestsList());
                dispatch(GetAllRequests());
        }).catch(error => { throw error; })
    }
}

export function UpdateRequest(data) {
    return function (dispatch) {
        return APIutil.editDataAPI(url.post_Request+"/"+data.RequestId,data).then(response => {
            dispatch(global_error_handling(response));  
            if(response.status == 200)
                dispatch(getRequestsList());
                dispatch(GetAllRequests());
        }).catch(error => { throw error; })
    }  
}


/* Delete Method for deleting single or multiple  Tenants*/

export function DeleteTenantRequests(requests_to_be_deleted) { 
    return function (dispatch) {
       return APIutil.deleteDataAPI(url.get_Request,requests_to_be_deleted).then(response => {
        dispatch(global_error_handling(response));  
               dispatch(getRequestsList());
               dispatch(GetAllRequests());
        }).catch(error => {
            throw error;
        })
    }
}


export function actionToStoreSuccess(response,actionType){
    return{
        type: actionType,
        getResponse: response,
    }
}